import { render } from "./UsersGamerList.vue?vue&type=template&id=9afe88e8"
import script from "./UsersGamerList.vue?vue&type=script&lang=js"
export * from "./UsersGamerList.vue?vue&type=script&lang=js"

import "./UsersGamerList.vue?vue&type=style&index=0&id=9afe88e8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__